// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../store/store'
// api
import * as migration from './api/migration'
import {displayErrorMessage, displaySuccessMessage, log} from '@insticator/insticator-ui'


export const fetchMigrationStatus = createAsyncThunk('commentingV2/getMigrationStatus',
  async siteId => {
    const response = await migration.getMigrationStatus(siteId)
    return response.data
  }
);

export const updateMigrationStatus = createAsyncThunk('commentingV2/updateMigrationStatus',
async (payload, { rejectWithValue }) => {
    try {
      const { siteId, data } = payload
      const response = await migration.updateMigrationStatus(siteId, data)
      return response.data
    } catch(err) {
        const error = 'There was an issue on updating the migration status'
        store.dispatch(displayErrorMessage(error))
        return null
    }
}
);

export const fetchSitesWithV2Products = createAsyncThunk('commentingV2/getSitesWithV2Products',
  async accountId => {
    const response = await migration.fetchSitesWithV2Products(accountId)
    return response.data
  }
);